import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export const store = new Vuex.Store({
    state: {
        os: 0,
        endpoint:'/api/v1/',

    },
    getters: {},
    mutations: {
        myOs(state) {
            if (navigator.userAgent.indexOf ('Windows') !== -1) state.os = 1;
            if (navigator.userAgent.indexOf ('Linux') !== -1) state.os = 2;
            if (navigator.userAgent.indexOf ('Mac') !== -1) state.os = 3;
        }
    },
    actions: {},

});
store.commit('myOs');